<template>
  <div ref="BaseballBate" class="text-justify transparent">
    <h1 class="text-center">{{ $t("portfolio.baseballBate.pageLabel") }}</h1>
    <hr class="primary" />

    <h2>{{ $t("portfolio.baseballBate.subtitle") }}</h2>
    <hr class="secondary" />
    <p>{{ $t("portfolio.baseballBate.paragraph") }}</p>
    <baseball-bate-instance />
  </div>
</template>

<script>
const BaseballBateInstance = () =>
  import(/* webpackChunkName: "BaseballBatePage" */ "@/components/Portfolio/BaseballBateInstance");

export default {
  name: "BaseballBate",
  components: {
    BaseballBateInstance
  }
};
</script>
